const Texts = (page, type) => {
    const Text = {
        about: {
            title: 'О компании',
            description: 'специализируется на поставке оборудования и программного обеспечения от ведущих производителей на мировом рынке. Мы стремимся всегда оправдывать ожидания клиентов, использовать проверенные методы ведения бизнеса, и подключать к проекту только тех специалистов, которой обладают необходимыми техническими знаниями и навыками',
            description2: 'гарантирует Вам обеспечение успешного завершения проекта, вне зависимости от его сложности и объемов',
            subtitle: 'Сотрудничество с VR Global предоставит Вам:',
            services: [
                'Наши профессиональные специалисты чаще сталкиваются со сложными задачами, чем рядовой IT инженер. Это позволит сделать процесс внедрения более безболезненным и эффективным для клиента.',
                'использованию новых технологий, инструментов и программного обеспечения, клиент получает необходимые внедрения, исключая риск возникновения простоев.',
                'Клиент получает услугу, объем и критерии оценки которой прописаны в договоре между сторонами.'
            ],
            servicesTitle: [
               'Экспертный подход.',
                'Снижение затрат. ,',
            ],
        },
        products: {
            title: 'Наши продукты',
            h11: 'Лицензионное программное обеспечение',
            h12: 'Серверы',
            h13: 'Системы хранения данных (СХД)',
            h14: 'Персональные компьютеры',
            h21: 'Оперативная память',
            h22: 'Процессоры',
            h23: 'Системы безопастности',
            h24: 'Телекоммуникационное оборудование и телефония',
            h31: 'Контрольно - измерительное оборудование',
            h32: 'Блоки питания (БП)',
            h33: 'Интерфейсные устройства и платы',
            h34: 'Коммутаторы и маршрутизаторы',
            p1: 'Помощь в подборе, поставка, инсталляция, настройка, техническое обслуживание любого IT оборудования для вашего бизнеса',
            p2: 'Помощь в подборе, поставка, настройка, техническая поддержка любого программного обеспечения для вашего бизнеса',
            },
        partners: {
           title: 'Наши партнеры',
        },
        homepage: {
            title: 'VR GLOBAL',
            description: 'Комплексные решения для автоматизации вашего бизнеса',
            services: 'Наши услуги',
            h1: 'СИСТЕМНАЯ ИНТЕГРАЦИЯ, ПРОЕКТИРОВАНИЕ И СОЗДАНИЕ КОРПОРАТИВНЫХ СЕТЕЙ',
            h2: 'СОЗДАНИЕ ПОЛНОМАСШТАБНЫХ ИНФОРМАЦИОННЫХ СИСТЕМ УРОВНЯ ПРЕДПРИЯТИЯ',
            h3: 'РЕШЕНИЯ ПО БЕЗОПАСНОСТи',
            h4: 'ИНФРАСТРУКТУРНЫЕ РЕШЕНИЯ',
            h5: 'Техническая поддержка и сервисные услуги',
            h6: 'Решения в области центров обработки данных и СХД',
            advantage: 'Преимущества',
            adv1: 'Специализированные решения',
            adv2: 'Весь товар сертифицирован',
            adv3: 'Оперативная доставка заказчику',
            partners: 'наши партнеры',
        },
        contacts: {
            title: 'Мы на связи',
            subtitle: 'Остались вопросы?',
            subtitle2: 'Позвоните или напишите нам и наш специалист свяжется с вами в ближайшее время и ответит на все ваши вопросы.',
            phone: '+7 (771) 255-80-01',
            email: 'info@vrglobal.kz',
            address: 'г. Алматы, пр. Назарбаева д. 193',
            footer: 'Компексные решения для автоматизации вашего бизнеса',
        }
    };
    return Text[page][type];
};

export default Texts;
